import {
  GET_TEACHER_SERVICES_LOADING,
  GET_TEACHER_SERVICES_SUCCESS,
  GET_TEACHER_SERVICES_ERROR,
  GET_AGE_LEVEL_LOADING,
  GET_AGE_LEVEL_SUCCESS,
  GET_AGE_LEVEL_ERROR,
  GET_SPECIALIZATION_LOADING,
  GET_SPECIALIZATION_SUCCESS,
  GET_SPECIALIZATION_ERROR,
  GET_SKILL_LEVEL_LOADING,
  GET_SKILL_LEVEL_SUCCESS,
  GET_SKILL_LEVEL_ERROR
} from 'actions/metaActions';

const INITIAL_STATE = {
  services: [],
  serviceStatus: 'INIT',
  ageLevels: [],
  ageLevelStatus: 'INIT',
  specializations: [],
  specializationStatus: 'INIT',
  skillLevels: [],
  skillLevelStatus: 'INIT'
};

export default function teacherReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_TEACHER_SERVICES_LOADING:
      return {
        ...state,
        serviceStatus: 'LOADING'
      };
    case GET_TEACHER_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
        serviceStatus: 'SUCCESS'
      };
    case GET_TEACHER_SERVICES_ERROR:
      return {
        ...state,
        services: [],
        serviceStatus: 'FAIL'
      };
    case GET_AGE_LEVEL_LOADING:
      return {
        ...state,
        ageLevelStatus: 'LOADING'
      };
    case GET_AGE_LEVEL_SUCCESS:
      return {
        ...state,
        ageLevels: action.payload,
        ageLevelStatus: 'SUCCESS'
      };
    case GET_AGE_LEVEL_ERROR:
      return {
        ...state,
        ageLevels: [],
        ageLevelStatus: 'FAIL'
      };
    case GET_SPECIALIZATION_LOADING:
      return {
        ...state,
        specializationStatus: 'LOADING'
      };
    case GET_SPECIALIZATION_SUCCESS:
      return {
        ...state,
        specializations: action.payload,
        specializationStatus: 'SUCCESS'
      };
    case GET_SPECIALIZATION_ERROR:
      return {
        ...state,
        specializations: [],
        specializationStatus: 'FAIL'
      };
    case GET_SKILL_LEVEL_LOADING:
      return {
        ...state,
        skillLevelStatus: 'LOADING'
      };
    case GET_SKILL_LEVEL_SUCCESS:
      return {
        ...state,
        skillLevels: action.payload,
        skillLevelStatus: 'SUCCESS'
      };
    case GET_SKILL_LEVEL_ERROR:
      return {
        ...state,
        skillLevels: [],
        skillLevelStatus: 'FAIL'
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/metaReducer.js